import { Directive, forwardRef, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[mustContainCharacters]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MustContainCharactersDirective),
            multi: true,
        },
    ],
    standalone: false
})
export class MustContainCharactersDirective {
  @Input('mustContainCharacters') specialCharacters: string;

  validate(control: UntypedFormControl) {
    return this.specialCharacters
      ? validateHasSpecialCharacters(this.specialCharacters)(control)
      : null;
  }
}

export function validateHasSpecialCharacters(characterList: string | RegExp) {
  return (control: UntypedFormControl) => {
    let SPECIAL_CHARACTER_REGEX = new RegExp(characterList);

    return SPECIAL_CHARACTER_REGEX.test(control.value)
      ? null
      : {
          mustHaveSpecialCharacter: true,
        };
  };
}
